export default "__VITE_ASSET__20053b8b__"